import { combineReducers } from 'redux';
import UserReducer from './UserReducer';
import AdminUserReducer from './admin/UserReducer';
import NotificationReducer from './NotificationReducer';
import physicianAppointmentReducer from './educator/AppointmentReducer';
import adminModuleReducer from './educator/adminModuleReducer';
import physicianMyPatientInfoReducer from './educator/MyPatientInfoReducer';
import DashBoardReducer from './educator/DashBoardReducer';
import VideoCallReducer from './VideoCallReducer';
import VisitInformationReducer from './educator/VisitInformationReducer';
import patientAppointmentReducer from './student/AppointmentReducer';
import MyProviderReducer from './student/MyProviderReducer';
import DashBoardPatientReducer from './student/DashBoardPatientReducer';
import PatientVisitInformationReducer from './student/VisitInformationReducer';
import NetworkInState from './NetworkReducer';
import PushNotificationReducer from './PushNotificationReducer';
import AdminNotificationReducer from './admin/NotificationReducer';
import ChatReducerList from './ChatReducer';
import UnreadReducerCount from './UnreadReducerCount';
import WhiteBoardReducerList from './WhiteBoardReducer';
import latestMessageReducer from "./latestMessageReducer";


const rootReducer = combineReducers({
    NetworkInState,
    UserReducer,
    NotificationReducer,
    PushNotificationReducer,
    physicianAppointmentReducer,
    adminModuleReducer,
    DashBoardReducer,
    physicianMyPatientInfoReducer,
    VideoCallState: VideoCallReducer,
    VisitInformationState: VisitInformationReducer,
    AdminNotificationReducer,
    ChatReducerList,
    UnreadReducerCount,
    WhiteBoardReducerList,
    latestMessageReducer,

    /**
     * Patient Reducers
     */
    patientAppointmentState: patientAppointmentReducer,
    myProviderState: MyProviderReducer,
    DashBoardPatientReducer,
    PatientVisitInformationReducer,
    AdminUserState: AdminUserReducer,
});

export default rootReducer;
